import React from "react";
import { Button, InputNumber } from "antd";

const SpinachDashboardControls = ({
  minLeafSizeInput,
  maxLeafSizeInput,
  setMinLeafSizeInput,
  setMaxLeafSizeInput,
  savingLeafSize,
  handleSaveLeafSize,
  minimumIdealHarvestLeafSize,
  maximumIdealHarvestLeafSize,
  actionsDisabled,
  onShowMap,
  onSaveAllData,
  userData,
  greenHouseLabel,
}) => {
  return (
    <div className="flex flex-row xl:flex-col justify-between items-center xl:items-stretch w-full gap-4 xl:gap-2 mb-4">
      <div className="flex flex-row md:flex-col items-center md:items-stretch gap-4 md:gap-2">
        <div className="flex items-center">
          <span className="mr-2 whitespace-nowrap">Min Leaf Size:</span>
          <InputNumber
            min={0}
            step={0.1}
            value={minLeafSizeInput}
            onChange={setMinLeafSizeInput}
            disabled={savingLeafSize}
            style={{ width: 80 }}
          />
        </div>

        <div className="flex items-center">
          <span className="mr-2 whitespace-nowrap">Max Leaf Size:</span>
          <InputNumber
            min={0}
            step={0.1}
            value={maxLeafSizeInput}
            onChange={setMaxLeafSizeInput}
            disabled={savingLeafSize}
            style={{ width: 80 }}
          />
        </div>

        <Button
          type="primary"
          onClick={handleSaveLeafSize}
          loading={savingLeafSize}
          disabled={
            minLeafSizeInput === minimumIdealHarvestLeafSize &&
            maxLeafSizeInput === maximumIdealHarvestLeafSize
          }
          className="w-auto md:w-full"
        >
          Save
        </Button>
      </div>

      <div className="flex flex-row md:flex-col justify-end xl:justify-start items-center md:items-start gap-4 md:gap-2">
        <Button
          disabled={actionsDisabled}
          onClick={onShowMap}
          className={`w-auto md:w-full min-w-[200px] rounded-md hover:shadow-2xl transition-transform duration-300 hover:scale-105 ${
            userData?.is_superuser ? "xl:mr-0" : ""
          }`}
        >
          Show {greenHouseLabel} on Map
        </Button>

        {userData?.is_superuser && (
          <Button
            type="primary"
            onClick={onSaveAllData}
            disabled={actionsDisabled}
            className="w-auto md:w-full min-w-[200px] rounded-md hover:shadow-2xl transition-transform duration-300 hover:scale-105"
          >
            Save All Data
          </Button>
        )}
      </div>
    </div>
  );
};

export default SpinachDashboardControls;
